import React, { useEffect, useState, useRef } from "react";
import {
	DetalleGridItemWrapper,
	Header,
	HeaderInfo,
	Model,
	ButtonsWrapper,
	ImgCol,
	InfoCol,
	HeaderTop,
	PriceNote,
} from "./styled";
import {
	CustomButton,
	OfertaConsumo,
	OfertaLegal,
} from "../../../assets/styles/commonStyles";
import ModeloAccordion from "../ModeloAccordion";

const ModeloDetalleGridItem = (props) => {
	const {
		cols,
		image,
		preTitle,
		title,
		subtitle,
		price,
		priceExtra,
		priceNote,
		model,
		buttons,
		featuresList,
		collapseSlidesFeatures,
		setCollapseSlidesFeatures,
		consumo,
		legal,
	} = props;

	const infoColRef = useRef();
	const [infoColHeight, setInfoColHeight] = useState();
	const [isFeaturesOpen, setIsFeaturesOpen] = useState(false);

	const calculateImgColHeight = (windowWidth) => {
		if (windowWidth < 992) {
			setInfoColHeight("auto");
		} else {
			setInfoColHeight(`${infoColRef.current.clientHeight}px`);
		}
	};

	useEffect(() => {
		if (infoColRef.current) {
			calculateImgColHeight(window.innerWidth);
		}
	}, [infoColRef.current]);

	const resizeListener = () => {
		if (infoColRef.current) {
			calculateImgColHeight(window.innerWidth);
		}
	};

	useEffect(() => {
		if (!isFeaturesOpen) {
			resizeListener();
			window.addEventListener("resize", resizeListener);

			return () => {
				window.removeEventListener("resize", resizeListener);
			};
		}
	}, [isFeaturesOpen]);

	return (
		<DetalleGridItemWrapper
			cols={cols}
			noPaddingTopBot={true}
			data-numero="2"
		>
			{cols === "1" ? (
				<>
					<ImgCol fixedHeight={infoColHeight}>
						<figure>
							<img src={image} alt={title} />
						</figure>
					</ImgCol>
					<InfoCol ref={infoColRef}>
						<Header cols={cols}>
							{(preTitle || subtitle) && (
								<HeaderTop>
									{preTitle && <h2>{preTitle}</h2>}
									{subtitle && (
										<h3
											dangerouslySetInnerHTML={{
												__html: subtitle,
											}}
										/>
									)}
								</HeaderTop>
							)}
							<HeaderInfo cols={cols} priceExtra={priceExtra}>
								<h3 dangerouslySetInnerHTML={{ __html: title }} />
								{/*<h4>*/}
								{/*	{price}{" "}*/}
								{/*	<span style={{ textDecoration: "underline" }}>*/}
								{/*		{priceExtra}*/}
								{/*	</span>*/}
								{/*</h4>*/}
								<PriceNote>{priceNote}</PriceNote>
							</HeaderInfo>
							<ButtonsWrapper cols={cols}>
								{buttons.map((button, index) => (
									<div key={index}>
										<CustomButton
											layout="dark"
											href={button.url}
											target={
												button.nuevaVentana ? "_blank" : "_top"
											}
											data-btn_solicitaroferta={
												button.dataBtnSolicitarOferta
											}
											data-financiacion={button.dataFinanciacion}
											data-modeledition={button.dataModelEdition}
										>
											{button.text}
										</CustomButton>
									</div>
								))}
							</ButtonsWrapper>
						</Header>
						<Model>
							<p>{model}</p>
						</Model>
						{featuresList && (
							<ModeloAccordion
								items={featuresList}
								collapseSlidesFeatures={collapseSlidesFeatures}
								setCollapseSlidesFeatures={setCollapseSlidesFeatures}
								setIsFeaturesOpen={setIsFeaturesOpen}
							/>
						)}
					</InfoCol>
					<div style={{ marginTop: "20px" }}>
						{consumo && (
							<OfertaConsumo
								dangerouslySetInnerHTML={{ __html: consumo }}
							/>
						)}
						{legal && (
							<OfertaLegal dangerouslySetInnerHTML={{ __html: legal }} />
						)}
					</div>
				</>
			) : (
				<>
					<Header>
						<figure>
							<img src={image} alt={title} />
						</figure>
						<HeaderInfo priceExtra={priceExtra}>
							{preTitle && <h5>{preTitle}</h5>}
							{subtitle && (
								<h6
									dangerouslySetInnerHTML={{
										__html: subtitle,
									}}
								/>
							)}
							<h3 dangerouslySetInnerHTML={{ __html: title }} />
							{/*<h4>*/}
							{/*	{price}*/}
							{/*	<span>*/}
							{/*		{" "}*/}
							{/*		<span style={{ textDecoration: "underline" }}>*/}
							{/*			{priceExtra}*/}
							{/*		</span>*/}
							{/*	</span>*/}
							{/*</h4>*/}
							<PriceNote>{priceNote}</PriceNote>
						</HeaderInfo>
						<ButtonsWrapper>
							{buttons.map((button, index) => (
								<div key={index}>
									<CustomButton
										layout="light2"
										href={button.url}
										target={button.nuevaVentana ? "_blank" : "_top"}
										data-btn_solicitaroferta={
											button.dataBtnSolicitarOferta
										}
										data-financiacion={button.dataFinanciacion}
										data-modeledition={button.dataModelEdition}
									>
										{button.text}
									</CustomButton>
								</div>
							))}
						</ButtonsWrapper>
					</Header>
					<Model>
						<p>{model}</p>
					</Model>
					{featuresList && (
						<ModeloAccordion
							items={featuresList}
							collapseSlidesFeatures={collapseSlidesFeatures}
							setCollapseSlidesFeatures={setCollapseSlidesFeatures}
							setIsFeaturesOpen={setIsFeaturesOpen}
						/>
					)}
					<div style={{ marginTop: "20px" }}>
						{consumo && (
							<OfertaConsumo
								dangerouslySetInnerHTML={{ __html: consumo }}
							/>
						)}
						{legal && (
							<OfertaLegal dangerouslySetInnerHTML={{ __html: legal }} />
						)}
					</div>
				</>
			)}
		</DetalleGridItemWrapper>
	);
};

export default ModeloDetalleGridItem;
